import React from 'react';
import {
  Button,
  IconButton,
  Text,
  VStack,
  Heading,
  HStack,
  Divider,
  Link,
  Grid,
  ButtonGroup,
  AspectRatio,
  Image,
  Flex,
  Stack,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Minimap, NormalSpinner } from '../../../components';

const SingleHoop = ({
  hoop, page, showClusterGrid, numOfClusterHoops, onAddToExistingHoop, toggleImgFullscreen, paginatePrev, paginateNext,
}) => {
  if (!hoop) {
    return (
      <Grid
        templateColumns="repeat(auto-fit, minmax(350px, 1fr))"
        h="96"
        overflowX="hidden"
      >
        <NormalSpinner />
      </Grid>
    );
  }

  return (
    <Grid
      templateColumns="repeat(auto-fit, minmax(350px, 1fr))"
      h="full"
      overflowX="hidden"
    >
      <Flex position="relative">
        <IconButton
          onClick={toggleImgFullscreen}
          aria-label="Close"
          icon={<FontAwesomeIcon icon={[ 'fas', 'expand-alt' ]} size="lg" />}
          colorScheme="blackAlpha"
          size="sm"
          pos="absolute"
          right="4"
          bottom="4"
          rounded="full"
          zIndex="overlay"
        />
        <AspectRatio w="full" ratio={1 / 1}>
          <Image
            src={hoop?.image?.url}
            objectFit="cover"
            fallback={<NormalSpinner />}
          />
        </AspectRatio>
      </Flex>

      <VStack
        align="stretch"
        spacing="6"
        p="6"
        pb="0"
      >
        <VStack align="flex-start" spacing="1">
          <Heading as="h1" fontSize="xl" noOfLines="3">
            {hoop.location.formatted_address}
          </Heading>
          <Text fontSize="sm">
            {hoop.location.country || hoop.location.locality}
          </Text>
          {hoop.location.isNotConsideredExactAddress && (
            <Text fontSize="xs" fontStyle="italic">
              Contributor did not submit an exact address
            </Text>
          )}
        </VStack>
        <Link
          href={`https://www.instagram.com/${hoop.contributor.instagramHandle}/`}
          isExternal
          color="brand.red.600"
          w="max-content"
        >
          <HStack justify="flex-end">
            <FontAwesomeIcon icon={[ 'fab', 'instagram' ]} size="lg" />
            <Text>{`@${hoop.contributor.instagramHandle}`}</Text>
          </HStack>
        </Link>

        {hoop.caption && (
          <Text>{hoop.caption}</Text>
        )}
        <Minimap
          initialCenter={hoop.position}
          height={250}
        />
        <ButtonGroup
          as={Stack}
          size="md"
          direction={[ 'column', 'row' ]}
          align={[ 'center' ]}
          justifyContent={[ 'space-evenly' ]}
          spacing="0"
          my="4"
          h="full"
        >
          {numOfClusterHoops > 1 && (
            <Button
              variant="solid"
              colorScheme="brand.red"
              rounded="full"
              onClick={() => showClusterGrid()}
              leftIcon={<FontAwesomeIcon icon={[ 'fas', 'th' ]} size="1x" />}
            >
              {`Hoops nearby (${numOfClusterHoops})`}
            </Button>
          )}
          <Button
            variant="solid"
            colorScheme="brand.blue"
            rounded="full"
            onClick={() => onAddToExistingHoop(hoop)}
            leftIcon={<FontAwesomeIcon icon={[ 'fas', 'camera' ]} size="1x" />}
          >
            Add an image
          </Button>
        </ButtonGroup>

        {numOfClusterHoops > 1 && (
          <VStack h="full" justify="flex-end" spacing="0">
            <Divider userSelect="none" />
            <ButtonGroup
              size="sm"
              variant="unstyled"
              color="brand.blue.600"
              spacing="24"
              py="4"
              w="full"
              justifyContent="center"
            >
              <IconButton
                onClick={() => paginatePrev()}
                aria-label="Go back"
                _focus={{ boxShadow: "none" }}
                icon={<FontAwesomeIcon icon={[ 'fas', 'arrow-left' ]} size="2x" />}
                disabled={page === 0}
              />
              <IconButton
                onClick={() => paginateNext()}
                aria-label="Go forward"
                _focus={{ boxShadow: "none" }}
                icon={<FontAwesomeIcon icon={[ 'fas', 'arrow-right' ]} size="2x" />}
                disabled={page + 1 === numOfClusterHoops}
              />
            </ButtonGroup>
          </VStack>)}
      </VStack>
    </Grid>
  );
};

export default SingleHoop;
